import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import moment from 'moment'

import Layout from '../../components/Layout'
import { API_ROOT } from '../../utils/constants'
import { apiError } from '../../api/account'
import { getListenPage } from '../../api/cookbook'

import '../PurchaseBook/styles.css'
import styles from './Listen.module.css'

// What a printed cookbook's QR code opens: the recipe's voice memo, no sign-in needed
const Listen = () => {
  const { token } = useParams()
  const [memo, setMemo] = useState(null)
  const [error, setError] = useState('')

  useEffect(() => {
    getListenPage(token)
      .then(({ data }) => setMemo(data))
      .catch((e) => setError(apiError(e, 'This voice memo is not shared any more.')))
  }, [token])

  return (
    <Layout title={memo ? `Listen: ${memo.recipe_name}` : 'Listen'} allowGuests>
      <div className={`cbPage ${styles.page}`}>
        {error ? (
          <section className="cbSection">
            <h1 className="cbTitle">Voice memo</h1>
            <p className="cbHint">{error}</p>
          </section>
        ) : !memo ? (
          <p className="cbMuted">Loading…</p>
        ) : (
          <section className={`cbSection ${styles.card}`}>
            <p className={styles.eyebrow}>From the family cookbook</p>
            <h1 className={styles.title}>{memo.recipe_name}</h1>
            {memo.recorded_by ? (
              <p className={styles.by}>
                In {memo.recorded_by.split(/\s+/)[0]}’s own voice
                {memo.recorded_at
                  ? `, recorded ${moment(memo.recorded_at).format('MMMM YYYY')}`
                  : ''}
              </p>
            ) : null}
            <audio
              className={styles.audio}
              controls
              preload="metadata"
              src={`${API_ROOT}${memo.audio_url}`}
            />
            <p className="cbMuted">
              Morsel keeps family recipes, photos and voices together.{' '}
              <a className="cbTextLink" href="https://getmorsel.com">
                Start your own family cookbook
              </a>
            </p>
          </section>
        )}
      </div>
    </Layout>
  )
}

export default Listen
